/**
 * Tailwind CSS implementation of the Container component.
 * Uses the Seeds container CSS class from container.css.
 */

import * as React from "react";
import type { TypeBoxProps } from "@sproutsocial/seeds-react-box";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const ContainerTailwind = React.forwardRef<HTMLDivElement, TypeBoxProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("seeds-container", className)}
        {...(rest as React.ComponentPropsWithoutRef<"div">)}
      >
        {children}
      </div>
    );
  }
);

ContainerTailwind.displayName = "ContainerTailwind";
